var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortHorizontalOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6129 14.2097L16.7071 14.2929L20.7071 18.2929C21.0676 18.6534 21.0953 19.2206 20.7903 19.6129L20.7071 19.7071L16.7071 23.7071C16.3166 24.0976 15.6834 24.0976 15.2929 23.7071C14.9324 23.3466 14.9047 22.7794 15.2097 22.3871L15.2929 22.2929L17.585 20H8C7.44772 20 7 19.5523 7 19C7 18.4872 7.38604 18.0645 7.88338 18.0067L8 18H17.585L15.2929 15.7071C14.9324 15.3466 14.9047 14.7794 15.2097 14.3871L15.2929 14.2929C15.6534 13.9324 16.2206 13.9047 16.6129 14.2097ZM12.7071 4.29289C13.0676 4.65338 13.0953 5.22061 12.7903 5.6129L12.7071 5.70711L10.414 8H20C20.5523 8 21 8.44772 21 9C21 9.51284 20.614 9.93551 20.1166 9.99327L20 10H10.414L12.7071 12.2929C13.0676 12.6534 13.0953 13.2206 12.7903 13.6129L12.7071 13.7071C12.3466 14.0676 11.7794 14.0953 11.3871 13.7903L11.2929 13.7071L7.29289 9.70711C6.93241 9.34662 6.90468 8.77939 7.2097 8.3871L7.29289 8.29289L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortHorizontalOutline);
export default __webpack_public_path__ + "static/media/sort_horizontal_outline.c53345d285e1b0fe277bf2106fb10919.svg";
export { ForwardRef as ReactComponent };